import { createFileRoute } from '@tanstack/react-router';
import type { JSX } from 'react';

import SupplierApiIntegration from '@/areas/supplier-integrations/SupplierApiIntegrations/SupplierApiIntegration';
import { canViewSourcingSettings } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute('/_authenticated/settings/_menu/organization/supplier-api-integrations')({
    staticData: {
        access: { permissions: canViewSourcingSettings },
        chrome: 'home',
    } satisfies PageStaticData,
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    return <SupplierApiIntegration />;
}
